import styled, { css } from "styled-components";

// `color` accepts any CSS color or the name of a theme color ("gray",
// "primary", "gray700", ...).
const resolveColor = (props: any): string => {
  if (!props.color) return props.theme.textColor;
  return props.theme.colors?.[props.color] ?? props.color;
};

const Text = styled.span.attrs((props: any) => ({
  size: props.size || 15,
  weight: props.weight || 400,
  color: resolveColor(props) + " !important",
}))`
  font-size: ${(props) => props.size}px;
  font-family: inherit;
  font-weight: ${(props) => props.weight};
  -webkit-font-smoothing: antialiased;
  color: ${(props) => props.color ?? ""};
  ${(props) =>
    props.onClick
      ? css`
          &:hover {
            cursor: pointer;
          }
        `
      : null};
`;

export const SpanItalic = styled.span`
  font-style: italic;
`;

export const CapText = styled(Text)`
  text-transform: capitalize;
`;

export default Text;
